//Константы для localStorage
export const FAVORITES_COUNT_KEY = 'signals_favorites_count';

//Константы для сортировки
export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
};

//Константы для фильтров
export const FILTERS = {
  ALL: null,
  TRENDING: 'trending',
  GAINERS: 'gainers',
  LOSERS: 'losers'
};

//Константы для состояний загрузки
export const LOADING_STATE = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

//Дефолтные значения
export const DEFAULT_SORT = {
  key: null,
  direction: 'desc'
};

export const DEFAULT_PAGINATION = {
  next: null,
  hasMore: false
};